import { faComments, faLock, faShoppingBasket } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import lowerFirst from 'lodash-es/lowerFirst';
import {
    BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON,
    BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON_NOTE, BAZAAR_PRODUCT_IS_RESERVED,
    BZ2_JUST_SEND_MESSAGE,
    BZ2_SEND_MESSAGE_ANONYMOUS,
} from 'mk/autogenerated/translations/ContactSellerForAnonymous.3a1d85179347cbd8e53cfc4fe240e05c'
import { bazaar_redirect_to_eshop_url } from 'mk/urls/functions';
import { ContactSellerActionsStep1 } from 'mk2/apps/bazaar/containers/ProductDetail/ContactSellerActionsStep1';
import { slugToParams } from 'mk2/apps/bazaar/helpers';
import { ProductEntity, ProductQuality } from 'mk2/apps/bazaar/schemas';
import { bazaarCheckoutUrl, bazaarProductDetailUrl } from 'mk2/apps/bazaar/urls';
import { signupUrl } from 'mk2/apps/users/urls';
import { Btn, BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './ContactSellerForAnonymous.mscss';

interface OwnProps {
    product: ProductEntity;
    canOrder: boolean;
    // TODO:
    //    https://www.figma.com/file/fcIlNMvgw3nTuw9daZBaPH/Modry-konik-UI?type=design&node-id=9204-18207&mode=design&t=Ybz4T0PiacA7eUHR-0
    //    when is the product reserved? we have no field like product.stockAmount
    //    "Produkty prockarov mozu mat dokonca niekolko usepesnych objednavok naraz (lebo nove veci sa daju kupit viac krat)"
    isReserved?: boolean;
    canSendMsg: boolean;
    sellerPhone: string;
    eshopUrl: string;
}

export const ContactSellerForAnonymous: React.FunctionComponent<OwnProps> = ({
    product, canOrder, isReserved, canSendMsg, sellerPhone, eshopUrl,
}) => {
    const orderBtn = canOrder ? (
        <>
            {isReserved && (
                <span className={styles.ContactSellerForAnonymous__isReserved}>
                    <FontAwesomeIcon icon={faLock} />
                    &nbsp;
                    {BAZAAR_PRODUCT_IS_RESERVED.split('|').map((line, i) => <>
                        <span key={`line-${i}`}>{line}</span>
                        <br key={`br-${i}`} />
                    </>)}
                </span>
            )}
            <Btn
              link={url(bazaarCheckoutUrl, slugToParams(product.slug))}
                type={BtnType.Blue}
                label={BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON}
                icon={faShoppingBasket}
                disabled={isReserved}
            />
            <span className={styles.ContactSellerForAnonymous__checkoutNote}>
                {BAZAAR_CHECKOUT_USE_BETTER_SHIPPING_PRICE_BUTTON_NOTE}
            </span>
        </>
    ) : null;

    const sendMsgBtnLabel = [ProductQuality.SERVICES, ProductQuality.JOBS].includes(product.quality)
        ? BZ2_JUST_SEND_MESSAGE
        : BZ2_SEND_MESSAGE_ANONYMOUS;
    const sendMsgBtnUrl = url(signupUrl, {}, {
        mkutm_medium: 'product',
        mkutm_campaign: 'buyer_registration_required',
        mkutm_source: 'modrykonik',
        mkutm_content: product.id,
        next: url(bazaarProductDetailUrl, slugToParams(product.slug), {
            openContactForm: 1,
        }),
    });
    const sendMsgBtn = canSendMsg
        ? canOrder
            ? <Link to={sendMsgBtnUrl}>{lowerFirst(sendMsgBtnLabel)}</Link>
            : <Btn type={BtnType.Blue} label={sendMsgBtnLabel} link={sendMsgBtnUrl} icon={faComments} />
        : null;

    const phoneLink = sellerPhone ? (
        <Btn
            type={BtnType.Link}
            label={sellerPhone}
            link={`tel:${sellerPhone}`}
            linkTarget="_blank"
            linkRel="noopener"
            sidePadding={BtnSidePadding.None}
            asAnchor
        />
    ) : null;

    const eshopLink = eshopUrl ? (
        <Btn
            type={BtnType.Link}
            label={eshopUrl.replace(/^https?:\/\//, '').split('/')[0]}
            link={bazaar_redirect_to_eshop_url(product.id)}
            linkTarget="_blank"
            linkRel="noopener"
            sidePadding={BtnSidePadding.None}
            asAnchor
        />
    ) : null;

    return (
        <ContactSellerActionsStep1
            orderBtn={orderBtn}
            sendMsgBtn={sendMsgBtn}
            phoneLink={phoneLink}
            eshopLink={eshopLink}
        />
    );
};
